module.exports = __webpack_public_path__ + "static/basic-info-e4bc29ba84ea3e0f1cbd114ec493d732.png";